const iconPaths = {
  container: "M4 8h24v18H4z M10 12v10 M16 12v10 M22 12v10 M4 5v3 M28 5v3 M4 26v3 M28 26v3",
  insurance: "M16 3 27 7v8c0 7-5 11-11 14C10 26 5 22 5 15V7z M10 16l4 4 8-9",
  oversized: "M3 22h26 M7 22V11h18v11 M11 11V7h10v4 M3 15v4 M29 15v4 M3 17h4 M25 17h4 M9 26a2 2 0 1 0 0 .01 M23 26a2 2 0 1 0 0 .01",
  warehouse: "M3 13 16 4l13 9v15H3z M9 28V15h14v13 M9 20h14 M9 24h14 M14 10h4",
  crane: "M5 28h10 M8 28V5h5v23 M4 5h23 M13 9l14-4 M23 5v12 M23 17v3a3 3 0 1 1-3-3 M8 12l5 5-5 5 5 6",
  multimodal: "M10 10h12v12H10z M14 13v6 M18 13v6 M5 12a12 12 0 0 1 21-4 M21 8h5V3 M27 20A12 12 0 0 1 6 24 M11 24H6v5",
};

export default function ServiceIcon({ type }) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={iconPaths[type]} />
    </svg>
  );
}
